import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ExpandableSection from 'widgets/ExpandableSection/ExpandableSection';
import { wa } from 'apps/analytics';
import { bopComponents, pageEventFields, pageEvents } from 'apps/products/analytics';
import PaginationLight from 'widgets/Pagination/PaginationLight';
import ReviewsSort from './ReviewsSort';
import SingleReview from './SingleReview';

import Recommend from './Recommend';
import { NO_OF_REVIEWS_ON_PAGE } from 'apps/products/actions/reviews';
import { scrollToCustomerReviews } from '../../utils/createReview';

export default class ReviewList extends PureComponent {
  static propTypes = {
    activePage: PropTypes.number,
    customerReviewId: PropTypes.number,
    fetchReviews: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    resetActivePage: PropTypes.func.isRequired,
    reviews: PropTypes.arrayOf(
      PropTypes.shape({
        rating: PropTypes.number.isRequired,
        customerNickname: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        text: PropTypes.string,
        helpfulVotes: PropTypes.number,
        unhelpfulVotes: PropTypes.number,
        creationDate: PropTypes.string.isRequired,
      })
    ).isRequired,
    router: PropTypes.object.isRequired,
    setActivePage: PropTypes.func.isRequired,
    sortOrder: PropTypes.string.isRequired,
    setSortOrder: PropTypes.func.isRequired,
    setHelpfulness: PropTypes.func.isRequired,
    sku: PropTypes.string.isRequired,
    totalCount: PropTypes.number.isRequired,
  };

  onSortChange = (sortOrder) => {
    this.props.setSortOrder(sortOrder);
    this.props.fetchReviews(this.props.sku, 0, NO_OF_REVIEWS_ON_PAGE, sortOrder);
    this.props.resetActivePage();
  };

  provideFastReviewDescriptionText = () => {
    const { customerReviewId } = this.props;
    const areThereNoFullPosts = this.props.totalCount === 0;

    if (areThereNoFullPosts) {
      return `No reviews, yet.${!customerReviewId ? ' Why not be the first?' : ''}`;
    }

    return null;
  };

  render() {
    const {
      reviews,
      totalCount,
      fetchReviews,
      sku,
      setHelpfulness,
      setActivePage,
      sortOrder,
      customerReviewId,
      activePage,
      isLoggedIn,
      router,
    } = this.props;

    const fastReviewDesctiptionText = this.provideFastReviewDescriptionText();
    return (
      <ExpandableSection
        preventStateReset
        collapsedHeight="2200px"
        onToggle={(isExpanded) => wa.triggerPageEventWithDescription(
          isExpanded ? pageEvents.BOP_SECTION_COLLAPSED : pageEvents.BOP_SECTION_EXPANDED,
          { [pageEventFields.BOP_COMPONENT]: bopComponents.REVIEW_LIST })
        }
      >

        {fastReviewDesctiptionText && (
          <div className="bop-reviews__fastReviewDescription">
            {fastReviewDesctiptionText}
          </div>
        )}

        {totalCount > 1 && (
          <div className="bop-reviews__navigationWrapper">
            <ReviewsSort
              onSortOrderChange={this.onSortChange}
              sortOrder={sortOrder}
            />
            <PaginationLight
              totalCount={totalCount}
              fetchReviews={fetchReviews}
              sku={sku}
              sortOrder={sortOrder}
              setActivePage={setActivePage}
              activePage={activePage}
            />
          </div>
        )}
        {reviews.map((review) => (
          <SingleReview
            key={review.reviewId}
            review={review}
            Controls={Recommend}
            sku={sku}
            setHelpfulness={setHelpfulness}
            customerReviewId={customerReviewId}
            isLoggedIn={isLoggedIn}
            router={router}
          />
        ))}

        <PaginationLight
          className="bop-reviews__paginationBottom"
          totalCount={totalCount}
          fetchReviews={fetchReviews}
          sku={sku}
          sortOrder={sortOrder}
          setActivePage={(delta) => {
            setActivePage(delta);
            scrollToCustomerReviews();
          }}
          activePage={activePage}
        />
      </ExpandableSection>
    );
  }
}
